import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

/**
 * Component for displaying an application hotspot table.
 * This table provides a structured representation of data, often used to highlight key information.
 */
@Component({
  selector: "app-application-hospot-table",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./application-hospot-table.component.html",
  styleUrl: "./application-hospot-table.component.scss",
})
export class ApplicationHospotTableComponent {
  @Input() data: any[] = [];

  /**
   * Formats a given date string into a user-friendly format.
   * @param {string} dateString - The date string to format.
   * @returns {string} - The formatted date string.
   */
  formatDate(dateString: string): string {
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  }
}
